// Blur number input when scrolling within a scrollable container via mousewheel/trackpad.
// This allows the screen to scroll without also changing the input value, which is unexpected.
document.addEventListener("wheel", () => {
  if (
    document.activeElement.type === "number" &&
    document.activeElement.closest(".overflow-auto")
  ) {
    document.activeElement.blur();
  }
});

// Add loading state to turbo stream links
document.addEventListener("click", (e) => {
  const link = e.target.closest("a"); // catch clicks anywhere in the <a>
  if (!link) return;

  // Skip special cases (anchors, js links, modifiers)
  if (
    link.target === "_blank" ||
    link.getAttribute("href")?.startsWith("#") ||
    e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey
  ) {
    return;
  }

  if (link.dataset.turboStream === "true") {
    link.ariaBusy = "true";
  }
}, true);

document.addEventListener("turbo:before-fetch-response", clearBusy);
document.addEventListener("turbo:fetch-request-error", clearBusy);
document.addEventListener("turbo:frame-missing", clearBusy);

function clearBusy() {
  document
    .querySelectorAll("a[aria-busy='true']")
    .forEach((el) => el.removeAttribute("aria-busy"));
}
